import * as React from "react";

import "./marketing-center-menu-mobile.scss"

import {AnyAction}                      from "@Common/react/any-action";
import {cs}                             from "@Common/react/chain-services";
import {UseState}                       from "@Common/react/use-state";
import {Dropdown}                       from "@Common/ui-components/dropdown/dropdown";
import {FontAwesomeIcon}                from "@fortawesome/react-fontawesome";
import {marketingCenterLinks}           from "@Xpresso/routes/marketing-center/common/marketing-center-common";
import {menuLink, menuDropdownItem}     from "@Xpresso/routes/marketing-center/desktop/menu-desktop/marketing-center-menu-desktop";   

export const MarketingCenterMenuMobile = ({helpMgmt, linkActive, url}) => cs(
    ['menuItemSelected', ({}, next) => UseState({
        initValue: null,
        next,
    })],
    ({menuItemSelected}) => (
        <div className="menu-mobile-TiO2">
            {
                Dropdown({
                    renderToggle: ({domRef, showExpand, showingExpand}) => (
                        <a
                            className={
                                showingExpand
                                ?
                                "menu-mobile-render-toggle expanded"
                                :
                                "menu-mobile-render-toggle"
                            }
                            xd-qa-type="dropdown"
                            xd-qa-name="menu-mobile"
                            ref={domRef}
                            onClick={() => showExpand(!showingExpand)}
                        >
                            <FontAwesomeIcon 
                                icon={require('@fortawesome/free-solid-svg-icons')[`${linkActive.value.icon}`]}
                                className='icon-left'
                            />
                            <div className="menu-mobile-header" >
                                {linkActive.value.linkLabel}
                            </div>                                                  
                            <i className={`fa icon-right ${showingExpand ? "fa-caret-up" : "fa-caret-down"}`}></i>                           
                        </a>                        
                    ),

                    renderExpand: ({close, domRef, position}) => (
                        <div
                            className="menu-mobile-render-expand"
                            style={position}
                            ref={domRef}
                        >
                            {
                                marketingCenterLinks.map(link => (
                                    <React.Fragment key={link.linkLabel}>
                                        {menuLink(link, linkActive, url)}
                                    </React.Fragment>
                                ))            
                            }
                            {helpMgmt?.value?.helpmgmt.length > 0 && menuDropdown('Resources', 'faLink', menuItemSelected, helpMgmt?.value?.helpmgmt)}
                            {AnyAction({action: close})}                     
                        </div>
                    )
                })
            }
            
        </div>
    ),
);


const menuDropdown = (name, icon, menuItemSelected, dropdownItems) => {
    return (
        <React.Fragment key={`${name}`} >
            <div 
                className={
                    name === menuItemSelected.value
                    ?
                    'menu-dropdown selected'
                    :
                    'menu-dropdown'
                }
                xd-qa-type='link'
                xd-qa-name={name}
                onClick={(e) => {
                    e.stopPropagation()
                    let current = menuItemSelected.value === name
                    ?
                    null            
                    :                    
                    name                       
                    menuItemSelected.onChange(current)
                }}
            >
                <FontAwesomeIcon 
                    icon={require('@fortawesome/free-solid-svg-icons')[icon]}
                    className='menu-dropdown-icon left'
                />
                <div className='menu-dropdown-text'>
                    {name}
                </div>
                {                  
                    <FontAwesomeIcon 
                        icon={require('@fortawesome/free-solid-svg-icons')
                            [ 
                            menuItemSelected.value === name
                            ?
                            'faCaretUp'
                            :
                            'faCaretDown'
                        ]}
                        className='menu-dropdown-icon right'
                    />                       
                }
            </div>
            {
                (dropdownItems && menuItemSelected.value === name)
                ?
                <div className="menu-dropdown-list">                                      
                {
                    dropdownItems.map(item => (
                        <React.Fragment key={item.name}>
                            {menuDropdownItem(item)}
                        </React.Fragment>                       
                    ))
                }          
                </div>                                
                :
                null
            }
        </React.Fragment>
    )
}